import { before, decorator } from 'ym-reporter-vue';
import wx from 'weixin-js-sdk';
import { mapActions } from 'vuex';
import { Dialog } from '@ymba/ym-ui';
import preCheckMixin from '@/mixins/order/precheck';
import getBenefitMixin from '@/mixins/order/getBenefit';
import createOrderMixin from '@/mixins/order/createOrder';
import { getSkuData } from '@/services/order';
import { commonLog } from '@/services/app';
import {
  getProductPath,
  redirectToLoginPage,
  isMiniWebView,
  locationHref,
  projectJump,
} from '@/utils';
import event from '@/utils/bus';

const joinProductMixin = {
  mixins: [preCheckMixin, getBenefitMixin, createOrderMixin],
  data() {
    return {
      mixinOriginPrice: 0,

      mixinShowSkuPopup: false,
      mixinSkuRecommendProduct: null,
      mixinSkuConfig: {
        stockThreshold: 50,
        showSoldOutSku: true,
        packages: [],
        stepperConfig: {
          title: '购买数量',
        },
      },
      mixinSkuProducts: [],

      mixinSkuSelected: null,
      mixinSkuEventListener: null,
      mixinInitialSku: null,
    };
  },
  props: {
    originPrice: {
      type: Number,
    },
  },
  watch: {
    originPrice(val) {
      this.mixinOriginPrice = val;
    },
  },
  methods: {
    ...mapActions([
      'Logout',
    ]),

    async _handleCreateOrder(id, type, count = 1) {
      return new Promise(async (resolve, reject) => {
        try {
          const action = await this.mixinOrderPreCheck(id, type, count);
          switch (action) {
            case 'showPayPopup': {
              try {
                await this.mixinGetBenefit(id, type);
                return resolve();
              } catch (e) {
                commonLog('getBenefitError', {
                  e,
                  targetId: id,
                  targetType: type,
                });
                return reject(e);
              }
            }
            case 'showPayCenter': {
              const query = { targetType: type, targetId: id, targetCount: count };
              const route = { name: 'PayCenter', query };
              this.$router.push(route);
              return resolve();
            }
            case 'confirmCoinExchange':
            case 'createOrder': {
              const params = {
                shouldPay: 0,
                shouldPayPoint: 0,
                couponIds: '',
                discountIds: '',
                addressId: 0,
                targetCount: 1,
                targetId: id,
                targetType: type,
                payActionSource: 'popup',
              };
              await this.mixinCreateOrder(params);
              return resolve();
            }
            case 'confirmPointExchange': {
              try {
                await Dialog.confirm({
                  message: '你确定进行兑换吗?',
                  confirmButtonText: '确认兑换',
                  closeOnClickOverlay: false,
                });
                return resolve();
              } catch (e) {
                return reject();
              }
            }
            default: {
              commonLog('orderPreCheckActionResolveError', {
                action,
                targetId: id,
                targetType: type,
              });
              return reject();
            }
          }
        } catch (e) {
          commonLog('joinProductError', {
            e,
            targetId: id,
            targetType: type,
          });
          return reject(e);
        }
      });
    },

    async _joinProduct(targetId, targetType, hint, page, resolve, reject) {
      try {
        // 调用 mixin 处理加入产品
        await this._handleCreateOrder(targetId, targetType);
        return resolve();
      } catch (e) {
        return reject();
      }
    },

    async _handleShowSkuPopup(targetType, targetId, resolve, reject) {
      try {
        const data = await getSkuData(targetType, targetId);

        // 默认值
        const defaultConfig = {
          stockThreshold: 50,
          showSoldOutSku: true,
          stepperConfig: {
            title: '购买数量',
          },
        };
        Object.assign(data.config, defaultConfig);

        // 处理选中
        data.config.packages.forEach((category) => {
          category.selectedItem = null;
          category.list.forEach((item) => {
            item.selected = false;
          });
        });

        this.mixinSkuRecommendProduct = data.recommendProduct;
        this.mixinSkuConfig = data.config;
        this.mixinSkuProducts = data.products;

        this.mixinShowSkuPopup = true;

        this.mixinInitialSku = this.mixinSkuSelected;
        return resolve();
      } catch (e) {
        this.mixinShowSkuPopup = false;
        return reject(e);
      }
    },

    @decorator(before(function (product) {
      const {
        targetId,
        targetType,
        hint,
        page,
      } = product;
      const { mixinOriginPrice } = this;
      if (mixinOriginPrice == null) return;
      // 原价为0，则类型为0
      const type = Number(mixinOriginPrice !== 0);
      this.$reporter.report('PAY_BUTTON_CLICK', {
        type, targetId, targetType, hint, page,
      });
    }))
    async mixinHandleClickJoinBtn(product, action = 'joinProduct') {
      return new Promise(async (resolve, reject) => {
        if (action === 'login') {
          // 退出登录
          await this.Logout();
          // 跳转至登录页面
          redirectToLoginPage(this.$router, 'push');
          return resolve();
        }
        const {
          targetId,
          targetType,
          hint,
          page,
        } = product;
        // 处理展示产品页面逻辑
        if (action === 'showProduct') {
          const route = getProductPath(targetType, targetId);
          projectJump(route);
          return resolve();
        }
        // 处理选择SKU
        if (action === 'showSkuPopup') {
          return this._handleShowSkuPopup(targetType, targetId, resolve, reject);
        }

        // 处理加入产品逻辑
        return this._joinProduct(targetId, targetType, hint, page, resolve, reject);
      });
    },

    setupSkuListeners() {
      this.mixinSkuEventListener = (res) => {
        this.mixinSkuSelected = res;
      };
      event.$on('sku-selected-all', this.mixinSkuEventListener);
    },

    payActionMode(url, sn) {
      if (isMiniWebView()) {
        wx.miniProgram.navigateTo({ url: `/pages/pay/index?sn=${sn}` });
        return;
      }
      locationHref(url);
    },

  },
  created() {
    this.mixinOriginPrice = this.originPrice;
    this.setupSkuListeners();
  },
  beforeDestroy() {
    if (this.mixinSkuEventListener && event) {
      event.$off('sku-selected-all', this.mixinSkuEventListener);
    }
  },
};

export default joinProductMixin;
